export enum Roles {
    KingsettUser = 'Kingsett User',
    Administrator = 'Administrator',
    PropertyManager = 'Property Manager',
    AccountManager = 'Account Manager',
}

export enum OtpVerificationType {
    Email = 'email',
    Phone = 'phone',
}